import FoodGroup from './food-group';
import {
  BaseEntity,
  JsonApiProperty,
  JsonApiRelationship,
  JsonApiResource,
} from '../jsonapi-provider';

@JsonApiResource({
  type: 'ingredient',
})
export default class Ingredient extends BaseEntity {
  name: string = '';
  description: string = '';
  @JsonApiProperty({ type: 'array' }) diets: string[] = [];
  @JsonApiProperty({ type: 'object' }) usdaFood: Record<string, any> | undefined = undefined;

  @JsonApiRelationship('food-group') foodGroup = new FoodGroup();

  constructor(
    id?: Ingredient['id'],
    name: Ingredient['name'] = '',
    description: Ingredient['description'] = '',
    diets: Ingredient['diets'] = [],
    foodGroup: Ingredient['foodGroup'] = new FoodGroup(),
    usdaFood: Ingredient['usdaFood'] = undefined
  ) {
    super();
    this.id = id;
    this.name = name;
    this.description = description;
    this.diets = diets;
    this.foodGroup = foodGroup;
    this.usdaFood = usdaFood;
  }
}
